import UserBlock from '#/containers/PDF/components/UserBlock'

const UserBlockPreview: React.FC<{ user: TopHap.UserInfo }> = ({ user }) => {
  if (user.isAnonymous !== false) return null
  return (
    <div className='flex flex-col items-end pb-3 pt-2'>
      <UserBlock className='w-full rounded-xl border p-3' user={user} />
      <a className='mt-1 text-sm text-primary underline hover:underline' href='/settings/profile' target='_blank'>
        Update User Information
      </a>
    </div>
  )
}

export default UserBlockPreview
